export default /* html */ `
<span class="btn btn-ui btn-block btn-large disabled">Already in your cart</span>
`;
